import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import PageNotFound from "../../../shared/presentations/PageNotFound";
import { UserCategories } from "./modules/user-categories/UserCategories";
import { Users } from "./modules/users/Users";
import AdministrationPage from "./pages/AdministrationPage";

export const AdministrationRoutes = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route path={match.path + "/users"}>
        <Users />
      </Route>
      <Route path={match.path + "/user-categories"}>
        <UserCategories />
      </Route>
      <Route path={match.path + "/"} exact={true}>
        <AdministrationPage />
      </Route>
      <Route>
        <PageNotFound />
      </Route>
    </Switch>
  );
};
